import axios from 'axios'
import BaseMixin from '@/shared/mixins/base.mixin'


const local = JSON.parse(localStorage.getItem('user'))
let token = ''
let refreshToken = ''

if (local) {
  token = local?.token
  refreshToken = local?.refreshToken
}

const qrcodeMixin = {
  mixins: [BaseMixin],
  methods: {
    async getQrCodeData(endpoint, externalId, sourceId)
    {
      const response  = await axios.post(endpoint, {
              externalId,
              sourceId,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          RefreshToken: refreshToken
        }
      })

      if (response.status !== 200) {
        throw new Error(response.data.message || 'Error')
      }

      return response.data
    }
  }
}

export default qrcodeMixin
